export const TRANSLATION_KEYS = {
  fieldLabel: 'partnerbasicinfo-profit-info',

  profitLabel: 'partnerbasicinfo-profit',
  yoyLabel: 'partnerbasicinfo-yoy',
}
